(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["faq-metaobject-items"] && !Shopify.designMode) return;
  try {
    (function() {
  document.querySelectorAll('[data-faq-mo-view-more]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var id = btn.getAttribute('data-faq-mo-view-more');
      var list = document.querySelector('[data-faq-mo-list="' + id + '"]');
      if (!list) return;

      list.querySelectorAll('[data-faq-hidden]').forEach(function(item) {
        item.style.display = '';
        item.removeAttribute('data-faq-hidden');
      });

      btn.parentElement.style.display = 'none';
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
